﻿import React, {useMemo} from 'react';
import {Autocomplete, AutocompleteProps, TextField} from "@mui/material";
import {useAutocompleteOptions} from "../../../hooks/autocomplete/useAutocompleteOptions";
import {useGetAdminCompanyNames} from "../../../hooks/admin/useGetAdminCompanyNames";
import {AccountType} from "../../constants/securspace-constants";

interface AdminCompanyNamesAutocompleteProps extends Omit<AutocompleteProps<any, any, any, any>, 'renderInput' | 'options'> {
  accountType?: typeof AccountType.SUPPLIER | typeof AccountType.BUYER;
  label?: string;
}

const AdminCompanyNamesAutocomplete = (props: AdminCompanyNamesAutocompleteProps) => {
  const {accountType, label = 'Company Name', ...autocompleteProps} = props;
  const {
    adminCompanyNames,
    isLoading
  } = useGetAdminCompanyNames({accountType})

  const renderInput = (params: any) => <TextField {...params} label={label} variant="standard" />

  const allAccountOptionsWithDefault = useMemo(() => [
    { id: '', label: 'All'},
    ...(adminCompanyNames?.map(item => ({
      id: item.id,
      label: item.label || item.companyName,
      searchAliases: [item.companyName],
    })) || [])
  ], [adminCompanyNames]);

  const {
    handleGetOptionLabel,
    handleIsOptionEqualToValue,
    filterOptions,
  } = useAutocompleteOptions({ autocompleteOptions: allAccountOptionsWithDefault, filterMode: 'flexible' });

  return <Autocomplete
    {...autocompleteProps}
    value={props.value}
    disablePortal
    disableClearable
    filterOptions={filterOptions}
    getOptionLabel={handleGetOptionLabel}
    isOptionEqualToValue={handleIsOptionEqualToValue}
    options={allAccountOptionsWithDefault}
    renderInput={renderInput}
    renderOption={(props, option) => <li {...props} key={option.id}>{option.label}</li>}
    loading={isLoading}
  />
}

export { AdminCompanyNamesAutocomplete };
